export default {
  actionMargin: '0 0 0 20px',
  actionMarginRtl: '0 20px 0 0'
}
